export const positionsTabs = [
	{id: 'open', label: 'Open Positions'},
	{id: 'pending', label: 'Pending Positions'},
	{id: 'close', label: 'Closed Positions'},
	{id: 'news', label: 'News'}
]

const openCells = [
	{
		id: 'asset_name',
		label: 'Asset',
		width: '12%'
	},
	{
		id: 'date',
		label: 'Open date',
		width: '14%'
	},
	{
		id: 'type',
		label: 'Type',
		width: '6%'
	},
	{
		id: 'price',
		label: 'Price',
		width: '7%'
	},
	{
		id: 'trade_size_lots',
		label: 'Trade size / Lots',
		width: '13%'
	},
	{
		id: 'fee',
		label: 'Commissions',
		width: '8%'
	},
	{
		id: 'swap',
		label: 'Swaps',
		width: '8%'
	},
	{
		button: true,
		id: 'pnl_close',
		label: 'PNL / Close',
		width: '9%'
	},
	{
		button: true,
		id: 'stop_loss',
		label: 'SL',
		width: '9%'
	},
	{
		button: true,
		id: 'take_profit',
		label: 'TP',
		width: '9%'
	},
	{
		button: true,
		id: 'view',
		label: 'View',
		width: '5%'
	}
]


const closeCells = [
	{
		id: 'asset_name',
		label: 'Asset',
		width: '13%'
	},
	{
		id: 'swap',
		label: 'Swap',
		width: '8%'
	},
	{
		id: 'id',
		label: 'ID',
		width: '6%'
	},
	{
		id: 'date',
		label: 'Date',
		width: '15%'
	},
	{
		id: 'type',
		label: 'Type',
		width: '6%'
	},
	{
		id: 'open_price',
		label: 'Open Price',
		width: '12%'
	},
	{
		id: 'fee',
		label: 'Fee',
		width: '7%'
	},
	{
		id: 'pnl',
		label: 'PNL',
		width: '8%'
	},
	{
		id: 'close_date',
		label: 'Close date',
		width: '15%'
	},
	{
		button: true,
		id: 'info',
		label: 'Info',
		width: '10%'
	}
]
const pendingCells = [
	{
		id: 'asset_name',
		label: 'Asset',
		width: '18%'
	},
	{
		id: 'id',
		label: 'ID',
		width: '8%'
	},
	{
		id: 'date',
		label: 'Date',
		width: '20%'
	},
	{
		id: 'type',
		label: 'Type',
		width: '8%'
	},
	{
		id: 'pending',
		label: 'Pending',
		width: '14%'
	},
	{
		id: 'now',
		label: 'Now',
		width: '12%'
	},
	{
		button: true,
		id: 'edit',
		label: 'Edit',
		path: '',
		width: '10%'
	},
	{
		button: true,
		id: 'cancel',
		label: 'Cancel',
		width: '10%'
	}
]


export const cellsObj = {
	close: closeCells,
	open: openCells,
	pending: pendingCells
}
